import upFirstLetter from "./upFirstLetter";
import {stripHtml} from "string-strip-html";

/**
 * Convert from camel to snake case.
 * @param {string} s
 * @returns {string}
 */
export function snakeToText(s: string): string {
    if (!s) {
        console.trace('sent a null to snakeToText');
        return '';
    }

    const sep = s.replace(/([-_][a-z])/ig, ($1) => {
        return $1.replace('-', ' ')
            .replace('_', ' ');
    });

    return sep.toLowerCase().split(' ').map(s => upFirstLetter(s)).join(' ');
}

/**
 * Strip html formatting and return a stripped string.
 *
 * @param {string} input
 * @param {string[]} ignoreTags
 * @returns {string}
 */
export function stripHTML(input: string, ignoreTags?: string[]): string {
    if (!input) return '';
    else {
        const firstPass = stripHtml(input, {
            stripTogetherWithTheirContents: ["script", "style", "xml", "class"],
            ignoreTags: ignoreTags ?? ['div', 'p', 'br', 'em', 'strong', 'b', 'i', 'strong', 'u', 'ul', 'ol', 'li', 'hr', 'img', 'a', 'h1', 'h2', 'h3', 'h4'],
            skipHtmlDecoding: true
        }).result ?? ''

        const stripped = firstPass
            .replaceAll(/(<[^>]+) class=".*?"/ig, '$1')
            .replaceAll(/(<[^>]+) style=".*?"/ig, '$1')
            .replaceAll(/(<[^>]+) style='.*?'/ig, '$1')
            .replaceAll(/(<[^>]+) href=".*?"/ig, '$1')
            .replaceAll(/(<[^>]+) href='.*?'/ig, '$1')
            .replaceAll(/·[\s?]+[&nbsp;]+/ig, '&nbsp;&nbsp;&bull; ')
            .replaceAll(/([0-9]+)\.[\s?]+[&nbsp;]+/g, '&nbsp;&nbsp;$1. ');

        return stripped;
    }
}